<script setup lang="ts">
  import { MyAccountRoute } from "@/constants/routes/myAccount"
  import { computed } from "vue"
  import { useRoute, useRouter } from "vue-router"
  import MaintenanceBanner from "@/components/shared/maintenance-banner/MaintenanceBanner.vue"
  import { PageHeader } from "@/components/ui/page-header"

  const router = useRouter()
  const route = useRoute()

  const title = computed(() => (route.meta?.title as string) || "")
  const hideBackButton = computed(() => route.meta?.hideBackButton as boolean)
  const backButtonPath = computed(
    () => (route.meta?.backButtonPath as string) || MyAccountRoute.home,
  )
  const handleBackClick = () => {
    router.push(backButtonPath.value)
  }
</script>
<template>
  <main class="container space-y-4 p-6 pb-12 sm:space-y-6">
    <div class="mt-2 flex items-baseline sm:mt-[18px] sm:justify-between">
      <div class="hidden min-w-[16px] sm:invisible sm:flex" />
      <div class="w-full basis-full sm:max-w-3xl sm:basis-auto">
        <PageHeader
          v-if="title"
          :title="title"
          :has-back-button="!hideBackButton"
          @back="handleBackClick"
        />
      </div>
      <div class="hidden min-w-[16px] sm:invisible sm:flex" />
    </div>
    <div class="flex items-baseline sm:justify-between">
      <div class="hidden min-w-[16px] sm:invisible sm:flex" />
      <div class="flex w-full flex-col sm:max-w-3xl">
        <MaintenanceBanner class="mb-4 sm:mb-6" />
        <slot />
      </div>
      <div class="hidden min-w-[16px] sm:invisible sm:flex" />
    </div>
  </main>
</template>
